import useSWR from 'swr';
import { apiClient, type SearchFilters } from '@/lib/api-client';
import { swrConfig, staticSWRConfig } from '@/lib/swr-config';

export function usePatterns(filters?: SearchFilters) {
  const queryKey = filters ? JSON.stringify(filters) : 'all';

  const { data, error, mutate, isValidating } = useSWR(
    `/patterns-${queryKey}`,
    () => apiClient.getPatterns(filters),
    {
      ...staticSWRConfig,
      dedupingInterval: 60000, // 1 minute
    }
  );

  return {
    patterns: data?.patterns,
    isLoading: !error && !data,
    isValidating,
    error,
    mutate,
  };
}

export function usePattern(id: string) {
  const { data, error, mutate, isValidating } = useSWR(
    id ? `/patterns/${id}` : null,
    () => apiClient.getPattern(id),
    {
      ...swrConfig,
      revalidateOnFocus: false,
    }
  );

  return {
    pattern: data?.pattern,
    isLoading: !error && !data,
    isValidating,
    error,
    mutate,
  };
}
